<template>
  <router-view></router-view>
</template>

<script>
  export default {
    name: 'share-product-page',
  };
</script>

<style scoped></style>
